module.exports = __webpack_public_path__ + "img/profit-icon4.42dbad30.png";